<template>
<div>
<v-card> 
<v-card-title>
<h2>{{ default_term_cd_description }} {{ ctitle }}</h2>
<v-spacer></v-spacer>
</v-flex>
<!--
<v-btn icon class="mx-0" @click="download">
  <v-icon title="Excel Download" color="green">save_alt</v-icon>
</v-btn>
-->
<v-btn icon class="mx-0" @click="reset">
   <v-icon title="Reload" color="blue">refresh</v-icon>
</v-btn>

<v-text-field clearable v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
<v-spacer></v-spacer>
<v-autocomplete label="Select Semester to Display" :items="semesters" v-model="term_cd" @change="fetchApp">
</v-autocomplete>
</v-card-title>

<v-divider></v-divider>

<v-data-table  :footer-props="{'items-per-page-options': [500,1000,5000]}"  :headers="filteredheaders" :loading=progress_bar_loading :items="filteredResults" :search="search" class="elevation-1" :options.sync="pagination" show-group-by group-by="gened_attr_names" multi-sort>

<v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

	<template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
          <span> {{ header.text }} </span>
	  <div v-if="headers_to_filter.includes(header.text)">
          <div v-if="filters.hasOwnProperty(header.value)">
								<v-autocomplete
									flat
									hide-details
									multiple
									attach
									chips
									full-width
									hide-no-data
									clearable
                 						        disable-lookup
									:items="columnValueList(header.value).sort()"
									v-model="filters[header.value]"
								>
                  											<template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 5">
											 <span> 
                        {{ item }} 
                      </span>
										</v-chip>
										<span v-if="index === 5" class="grey--text caption" > 
                      (+{{ filters[header.value].length - 5 }} others) 
                      </span>
									</template>
								</v-autocomplete>
							</div>
							</div>
	</template>


<template v-slot:item.name="{ item }">
<span><a target="_blank" title="Schedule" :href="'https://apps.uis.edu/dynamic-course-schedule/' + item.term_cd + '/' + item.crn" onclick="return popup(this.href, 800, 1024);">{{ item.coursename }}</a> ({{ item.crn }}) - {{ item.sect_title }} ({{ item.sched_type_desc }})</span>
</template>

<template v-slot:item.gened_attr_names="{ item }">
<span>{{ (item.gened_attr_names=='ZECCE only' ? 'ECCE only' : item.gened_attr_names) }}</span>
</template>

                    <template v-slot:item.action="{ item }">
                        <v-icon small color="teal" @click="showForm(item)" title="Edit" class="mr-2">mdi-pencil</v-icon>
                        <v-icon small color="pink" @click="deleteItem(item)" title="Delete">mdi-delete</v-icon>
                    </template>

</v-data-table>



</v-card>
  <v-snackbar v-model="snackbar" :timeout="5000" :color="snackcolor">
            {{ snacktext }}
            <v-btn color="white" text @click="snackbar = false">Close</v-btn>
  </v-snackbar>
</div>
</template>

<script>
import XLSX from 'xlsx';

export default {
        data() {
                return {
app_name: process.env.MIX_APP_NAME,
validationErrors: '',
term_cd: this.default_term_cd,
semesters: [
{text: 'Fall 2022', value: '420228'},
{text: 'Spring 2023', value: '420231'},
{text: 'Summer 2023', value: '420235'},
{text: 'Fall 2023', value: '420238'},
{text: 'Spring 2024', value: '420241'},
{text: 'Summer 2024', value: '420245'},
{text: 'Fall 2024', value: '420248'},
{text: 'Spring 2025', value: '420251'},
{text: 'Summer 2025', value: '420255'},
{text: 'Fall 2025', value: '420258'},
],
search: this.search_by,
fill:[],
headers_to_filter: ['Gened Attribute Name', 'Ecce Attribute Name', 'Credit Hours'],
filteredheaderarray: [],
headerarray:[],
index: -1,
progress_bar_loading: true,
                snackbar: false,
                snackcolor: '',
                snacktext: '',
dialog: false,
dialog_add: false,
dialog_update: false,
loadingStore: false,
loadingUpdate: false,
hide_headers:['crs_subj_cd', 'crs_nbr', 'sect_nbr', 'term_cd', 'crn', 'sect_title', 'sched_type_desc', 'sect_mtg_time_days', 'bldg_cd', 'room_nbr'],
rowsPerPageItems: [10,50,100,2000],
headers: [
{ text: 'Name', value: 'name', sortable: true, groupable: true, },
{ text: 'Meeting Times|Part of Term|Instructor', value: 'lecture_mode_day_time_instructor', sortable: false, groupable: false, },
{ text: 'crs_subj_cd', value: 'crs_subj_cd', sortable: true, groupable: true, },
{ text: 'crs_nbr', value: 'crs_nbr', sortable: true, groupable: false, },
{ text: 'sect_nbr', value: 'sect_nbr', sortable: true, groupable: false, },
{ text: 'term_cd', value: 'term_cd', sortable: true, groupable: false, },
{ text: 'crn', value: 'crn', sortable: true, groupable: false, },
{ text: 'sect_title', value: 'sect_title', sortable: true, groupable: false, },
{ text: 'sched_type_desc', value: 'sched_type_desc', sortable: true, groupable: true, },
{ text: 'sect_mtg_time_days', value: 'sect_mtg_time_days', sortable: true, groupable: false, },
{ text: 'bldg_cd', value: 'bldg_cd', sortable: true, groupable: true, },
{ text: 'room_nbr', value: 'room_nbr', sortable: true, groupable: false, },
{ text: 'Gened Attribute Name', value: 'gened_attr_names', sortable: true, groupable: true, width: 400, },
{ text: 'Ecce Attribute Name', value: 'ecce_attr_names', sortable: true, groupable: true, width: 400, },
{ text: 'Credit Hours', value: 'sect_credit_hours', sortable: true, groupable: true, width: 200, },
{ text: 'Actual Enrollment', value: 'sect_actual_enrl', sortable: false, groupable: false, },
                ],
                filters: {
crs_subj_cd:[],
crs_nbr:[],
sect_nbr:[],
term_cd:[],
crn:[],
sect_title:[],
sect_actual_enrl:[],
sched_type_desc:[],
sect_mtg_time_days:[],
bldg_cd:[],
room_nbr:[],
sect_credit_hours:[],
gened_attr_names:[],
ecce_attr_names:[],
                },
                selected:[],
                pagination: {

                },

                Results:[],
                dialog: false,
        }
        },
             created () {
                     this.initialize()
             },
watch: {
            dialog (val) {
                val || this.close()
            },
	    term_cd (val) {
		
	    },
        },
               mounted() {
                       console.log('Indexall component mounted');
 },
props: {
ctitle: {
             type: String,
             required: true,
                              },
default_term_cd: {
             type: String,
             required: true,
                              },
search_by: {
	type: String,
	required: false,
		              },			      
  },
       computed:{
                filteredResults() {
                return this.Results.filter(d => {
                        return Object.keys(this.filters).every(f => {
                                return this.filters[f].length < 1 || this.filters[f].includes(d[f])
                        })
                })
                },
		filteredheaders: { 
			get(){
			return this.headers.filter((h) => !this.hide_headers.includes(h.value)); 
			},
			set(newval){
			this.headers = newval;
			}
		},
		unfilteredheaders: { 
			get(){
			return this.headers.filter((h) => this.hide_headers.includes(h.value)); 
			},
			set(newval){
			this.headers = newval;
			}
		},
		default_term_cd_description() {
                        return typeof(this.semesters.find(entry => entry.value === this.term_cd) !== "undefined") ? this.semesters.find(entry => entry.value === this.term_cd).text : '';
                }
       },

methods:
       {
                columnValueList(val) {
                        //console.log(val)
                        return this.Results.map(d => d[val])
                },
               initialize()
               {
                        this.fetchApp()
                        this.filteredheaders = this.headers;
               },

		 async fetchApp(){
                       await axios.get('/' + this.app_name + '/api/v3/gened/courses/' + this.term_cd)
                               .then((response) => {
                                               this.Results = (response.data);
                                               this.progress_bar_loading = false;
                                               })
                       .catch(error => {});

         },

          customFilter(items, search, filter) {
                    search = search.toString().toLowerCase();
                    this.fill = items.filter(i => (
                                            Object.keys(i).some(j => filter(i[j], search))
                                            ))
                            //console.log(this.fill);
                    return this.fill;
            },
        reset()
                     {
                     this.fetchApp();
                     },
    download() {
      var first_record_json;
      var all_headers;
      var first_record_json;
      var first_record_json_keys;
      var all_headers_not;

      var local_delete = [];

      this.filteredheaders.forEach(element => this.filteredheaderarray.push(element.value));

      //ADDED because it was a computed value (template v-slot) that would not go in the download
      this.unfilteredheaders.forEach(element => this.filteredheaderarray.push(element.value));

      this.headers.forEach(element => this.headerarray.push(element.value));
      first_record_json = this.Results[0];

      //console.log(first_record_json);
      first_record_json_keys  = Object.keys(first_record_json);
      all_headers_not = first_record_json_keys.filter(x=> !this.filteredheaderarray.includes(x));
      // console.log(all_headers_not);
      // local_delete = this.fill;
      local_delete = this.filteredResults; // change this when I figure out how the customFilter should work
      // console.log(this.filter_delete);
      for (var k =0;k<local_delete.length;k++)
      {
        for(var i=0;i<all_headers_not.length;i++)
        {
                var key = all_headers_not[i];
                delete local_delete[k][key];
        }
      }
      // console.log(this.filter_delete[0]);
      var work = XLSX.utils.json_to_sheet(local_delete);
      var new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, work, "SheetJS");
                        var date = new Date();
      XLSX.writeFile(new_workbook, this.app_name + '_app_export_' + date.getTime() + '.xlsx');
                        this.filteredheaderarray = [];
      this.headerarray = [];
    },
    BackgroundColor: function(tcourse, key) {
      var result = '';
      console.log('The key is ', key);
      if(key == 'approved')
              {
                      if(tcourse.approved == 0)
                      {
                      result = 'badge p-2 h-3 font-weight-light badge-info'
                      }
              else
          {
            result = 'badge p-2 font-weight-light badge-success'
          }
      }

      return result;
    },
onEditorBlur(editor) {
      // console.log('editor blur!', editor)
    },
    onEditorFocus(editor) {
      // console.log('editor focus!', editor)
    },
    onEditorReady(editor, body = null) {},
    onEditorChange({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)
      this.content = html;
    },
 }
}
</script>
